import { createContext } from 'react';

export interface TimeEntryRefreshContextType {
  refreshKey: number;
  refreshTimeEntries: () => void;
}

/**
 * When applying overtime calculations, we need to ensure that the time entries are refreshed.
 * Because the time entries are using local state, we need to force a re-render
 * to ensure that the time entries are updated with the latest overtime calculations.
 */
const TimeEntryRefreshContext = createContext<TimeEntryRefreshContextType | undefined>(undefined);

export default TimeEntryRefreshContext;
